import { render, staticRenderFns } from "./DetailSection.vue?vue&type=template&id=21b999bc&scoped=true&"
import script from "./DetailSection.vue?vue&type=script&lang=js&"
export * from "./DetailSection.vue?vue&type=script&lang=js&"
import style0 from "./DetailSection.vue?vue&type=style&index=0&id=21b999bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b999bc",
  null
  
)

export default component.exports